import {
  AMEX,
  AMEX_TYPE,
  ENV_TEMPLATE,
  ENV_TEMPLATE_LABEL,
  EVENT,
  EVENT_ACTION,
} from '@utils/tracking/constants'
import {
  computeAmexLabel,
  getEventCategory,
  getTargetMetaData,
} from '@utils/tracking/utils'
import { snakeCase } from '@utils/utils'
import { type SyntheticEvent, useCallback } from 'react'

import { useTrackingWrapper } from './use-tracking-wrapper'

export const useTrackExternalLink = () => {
  const wrapper = useTrackingWrapper()
  return useCallback(
    (event: SyntheticEvent) => {
      if (wrapper) {
        let action = null
        let categorie = getEventCategory(wrapper)
        const { href, dataRole, dataType, isAmexLinkToTrack, defaultLabel } =
          getTargetMetaData(event)

        let libelle = defaultLabel
        // Exceptions
        if (isAmexLinkToTrack) {
          action = EVENT_ACTION.CLIC_NAVIGATION
          libelle = computeAmexLabel(href, libelle)
        } else if (dataType === 'cta') {
          action = EVENT_ACTION.CLIC_ACTION
          libelle = snakeCase(dataRole)
        } else if (dataType === 'hyperlink') {
          if (href.includes('.pdf')) {
            action = EVENT_ACTION.CLIC_TELECHARGEMENT
          } else if (href.includes('https://global.americanexpress.com')) {
            const type = Object.values(AMEX_TYPE).find((type) =>
              href.includes(type)
            )
            const suffix = type || ''
            categorie = `${ENV_TEMPLATE_LABEL[ENV_TEMPLATE[2]]}|${AMEX}`
            action = EVENT_ACTION.CLIC_SORTANT
            libelle = snakeCase(`${AMEX} ${suffix}`)
          }
        }

        wrapper.triggerEvent(EVENT.CLICK, event.currentTarget, {
          categorie,
          action,
          libelle,
        })
      }
    },
    [wrapper]
  )
}
